import React from 'react';
import { makeStyles } from '@material-ui/styles';
import {
  SearchResultsCount,
  SearchResultsPagination,
  ShowMoreLink,
} from '../../../components/search/SearchResults';

const useStyles = makeStyles((theme) => ({
  resultsContainer: {
    justifyContent: 'center',
    paddingBottom: theme.spacing(10)
  },
  resultsContent: {
    paddingTop: theme.spacing(1),
    [theme.breakpoints.up('xl')]: {
      paddingTop: 0,
    },
  },
}));

const OtherMarketPagination = () => {
  const classes = useStyles();

  return (
    <div className={classes.resultsContainer}>
      <SearchResultsCount />
      <ShowMoreLink />
      <SearchResultsPagination />
    </div>
  );
};

export default OtherMarketPagination;
